module.exports = __webpack_public_path__ + "static/media/icon-star.1a35cc6c.png";